export default __webpack_public_path__ + "static/business-account-cta-0afff9e3155536625392bb51f383196e.png";